import { AppMode } from "./AppContext";
let currentMode: AppMode | undefined = undefined;

const setCurrentMode = (mode: AppMode): void => {
  currentMode = mode;
};

export const getCurrentMode = (): AppMode | undefined => {
  return currentMode;
};


export const __internal = {
  setCurrentMode
};

